<template>
  <div>
    <v-row>
      <v-col cols="12">
        <timeline-events-config />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import TimelineEventsConfig from '../../../components/configs/timelineEventsConfig.vue'
export default {
  components: {
    TimelineEventsConfig
  }
}
</script>